// extracted by mini-css-extract-plugin
export default {"deductibleDaysSegmentedButton":"DeductibleDaysSelect_deductibleDaysSegmentedButton__1ziiN"};